export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export interface INewbuildingRecommendations {
  fullAddress: string;
  fullUrl: string;
  id: number;
  image: {
    id: number;
    miniUrl: string;
    thumbnail2Url: string;
    thumbnailUrl: string;
    fullUrl: string;
    isDefault: boolean;
    listingJkMini: string;
  };
  builder: {
    id: string;
  };
  name: string;
  priceDisplay: string;
  underground: {
    calcTimeCar: number;
    calcTimeCarAdmin: number;
    calcTimeWalk: number;
    calcTimeWalkAdmin: number;
    id: number;
    lineColor: string;
    lineId: number;
    name: string;
    time: number;
    transportId: number;
    transportType: ETransportType;
  };
}
